import { render } from "./SubHeaderLayout.vue?vue&type=template&id=fe41a2c2&scoped=true"
import script from "./SubHeaderLayout.vue?vue&type=script&lang=js"
export * from "./SubHeaderLayout.vue?vue&type=script&lang=js"

import "./SubHeaderLayout.vue?vue&type=style&index=0&id=fe41a2c2&lang=scss&scoped=true"

import exportComponent from "/var/www/fgc-dev-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe41a2c2"]])

export default __exports__